import { Checkbox, getFontCss, styleConstants } from '@paywithextend/components'
import React from 'react'
import { useSelector } from 'react-redux'
import BottomBox from 'src/components/BottomBox/BottomBox'
import TestId from 'src/components/TestId/TestId'
import Crncy from 'src/localization/Crncy'
import Trns from 'src/localization/Trns'
import { selectUserListModelFromState } from 'src/redux/selectors/auth.selectors'
import { selectDefaultCurrencyFromState } from 'src/redux/selectors/session.selectors'
import { toDollars } from 'src/utils/currency.utils'
import { css } from 'styled-components'

interface ReceiptsRequiredBoxProps {
  className?: string
  receiptRulesExempt?: boolean
  onChange: (val: boolean) => void
  virtualCardCurrency?: string
  receiptThresholdCents?: number
  showNote?: boolean
}

export const ReceiptsRequiredBox: React.FC<ReceiptsRequiredBoxProps> = (
  props,
): React.ReactElement => {
  const user = useSelector(selectUserListModelFromState)
  const defaultCurrency = useSelector(selectDefaultCurrencyFromState)

  return (
    <BottomBox
      className={props.className}
      label={<Trns source={'Receipt Rules'} />}
      collapsible
      css={css`
        display: flex;
        flex-direction: column;
      `}
    >
      <div
        css={css`
          ${getFontCss(
            14,
            styleConstants.colors.gray_darkest,
            styleConstants.fontFamilies.regular,
          )};
        `}
      >
        <Trns
          source={
            'If enabled, receipts will be required for transactions over ${limit} on this card.'
          }
          expressions={{
            limit: (
              <Crncy
                currency={
                  props.virtualCardCurrency || user?.currency || defaultCurrency
                }
                amount={toDollars(props.receiptThresholdCents ?? 0)}
                maximumFractionDigits={2}
              />
            ),
          }}
        />
      </div>
      {props.showNote && (
        <div
          css={css`
            ${getFontCss(
              14,
              styleConstants.colors.gray_darkest,
              styleConstants.fontFamilies.regular,
            )};
          `}
        >
          <Trns
            source={
              'Enabling or disabling will apply to all previous transactions.'
            }
          />
        </div>
      )}
      <TestId testId={'receiptRulesCheckbox'}>
        <Checkbox
          css={css`
            margin-top: 24px;
          `}
          label={<Trns source={'Enable receipt rules for this card'} />}
          isSelected={!props.receiptRulesExempt}
          onClick={(): void => {
            props.onChange(!props.receiptRulesExempt)
          }}
        />
      </TestId>
    </BottomBox>
  )
}

export default ReceiptsRequiredBox
